import React from "react";
import { Redirect } from "react-router-dom";
import { useUser } from "../../contexts/user-context";
import { canAccessAdminPath } from "../../utils/accessContext";

/**
 * Redirects assistants away from admin pages they are not allowed to read.
 * @param {{role: string, location: object, children: React.ReactNode}} props
 * @returns {React.ReactElement}
 */
const AssistantPageGuard = ({ role, location, children }) => {
  const { user, userLoading } = useUser();
  const pathname = location && location.pathname ? location.pathname : "";

  if (role === "assistant" && !userLoading) {
    if (!canAccessAdminPath(user, role, pathname)) {
      return <Redirect to="/admin/welcome" />;
    }
  }

  return children;
};

export default AssistantPageGuard;
